import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import api from "../utils/api";
import logger from "../utils/logger";

export const useCompanyForm = () => {
  const { t } = useTranslation();

  const schema = yup.object().shape({
    name: yup.string().required(t("companyRegister.fields.nameRequired")),
    fantasy_name: yup
      .string()
      .required(t("companyRegister.fields.fantasyNameRequired")),
    cnpj: yup
      .string()
      .required(t("companyRegister.fields.cnpjRequired"))
      .min(14, t("companyRegister.fields.cnpjInvalid")),
    area: yup.string().required(t("companyRegister.fields.areaRequired")),
    telephone: yup
      .string()
      .required(t("companyRegister.fields.telephoneRequired"))
      .min(10, t("companyRegister.fields.telephoneInvalid")),
    email: yup
      .string()
      .email(t("companyRegister.fields.emailInvalid"))
      .required(t("companyRegister.fields.emailRequired")),
    website: yup.string().url(t("companyRegister.fields.websiteInvalid")),
    instagram_profile: yup
      .string()
      .matches(
        /^[a-zA-Z0-9._]{1,30}$/,
        t("companyRegister.fields.instagramInvalid"),
      )
      .nullable(),
    subscription: yup
      .string()
      .required(t("companyRegister.fields.subscriptionRequired")),
    subscription_message: yup.string(),
    address: yup.object().shape({
      zip_code: yup
        .string()
        .required(t("companyRegister.fields.zipCodeRequired")),
      street: yup.string().required(t("companyRegister.fields.streetRequired")),
      number: yup.string().required(t("companyRegister.fields.numberRequired")),
      city: yup.string().required(t("companyRegister.fields.cityRequired")),
      state: yup.string().required(t("companyRegister.fields.stateRequired")),
      country: yup
        .string()
        .required(t("companyRegister.fields.countryRequired")),
    }),
  });

  const methods = useForm({ resolver: yupResolver(schema) });
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    t("companyRegister.steps.basicData"),
    t("companyRegister.steps.address"),
    t("companyRegister.steps.subscription"),
  ];

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const onSubmit = async (data: any) => {
    try {
      await api.post("/api/company", data);
    } catch (error) {
      logger.error("Erro ao cadastrar empresa", error);
    }
  };

  return { methods, steps, activeStep, handleNext, handleBack, onSubmit };
};

export default useCompanyForm;
